module.exports = __webpack_public_path__ + "d4982f6e553e4df5d1a6eee111b390bb.png";